// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1OzmB","imageUploader":"EGiftCard_imageUploader__2bK0V"};